import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    updates: {},
    lastUpdateTime: {},
};
const temperatureSlice = createSlice({
    name: "temperature",
    initialState,
    reducers: {
        setTemperatureUpdate: (state, action) => {
            const { nodeUid } = action.payload;
            state.updates[nodeUid] = action.payload;
            state.lastUpdateTime[nodeUid] = action.payload.timestamp;
        },
        clearTemperatureUpdates: (state) => {
            state.updates = {};
            state.lastUpdateTime = {};
        },
        removeTemperatureUpdate: (state, action) => {
            const nodeUid = action.payload;
            delete state.updates[nodeUid];
            delete state.lastUpdateTime[nodeUid];
        },
    },
});
export const { setTemperatureUpdate, clearTemperatureUpdates, removeTemperatureUpdate, } = temperatureSlice.actions;
export default temperatureSlice.reducer;
